export { default } from "./RecentlyViewedCarouselWithData";
